module.exports = __webpack_public_path__ + "assets/icon_maintenance.5304d811.svg";